import React, { useEffect, useState } from 'react'
import { getSingleWpFootballPost } from '../../../api/api_wp'
import { dateFormatter } from '../../../helpers/dateFormatter'

import Loader from '../../Loader/Loader'

function SinglePostWp({id}) {

    const [post, setPost] = useState()
    const [isLoading, setIsLoading] = useState(true)

    

    useEffect(() => {
        async function getSinglePostWp() {
            setIsLoading(true)
            const post = await getSingleWpFootballPost(id)
            setPost(post)
            setIsLoading(false)
        }
        getSinglePostWp()
    }, [id])

    return (
        <div className="container mb-3">
            {isLoading && <Loader />}
            <h2 className="font-weight-bold my-3">{post?.title?.rendered}</h2>
            <p className="text-muted"><small>Av Mads B / {dateFormatter(post?.date)}</small></p>
            <img src={post?.acf.featured_image_post} alt="" className="img-fluid" />
            <div className="my-4">
                <div dangerouslySetInnerHTML={{ __html: post?.content.rendered }}></div>
            </div>
            
        </div>
    )
}
export default SinglePostWp